/**
 * Career plan — beplan kariérní struktura.
 * Source: uploaded image by user (2026-04-22).
 * T1/T2/R1 (trainee + starting reprezentant) + managerial ladder VR2 → SSD.
 */
export const CAREER_POSITIONS = [
  { id: "T1",  label: "T1 Trainee 1",                koef: 62.5,  rank: 1 },
  { id: "T2",  label: "T2 Trainee 2",                koef: 75.0,  rank: 2 },
  { id: "R1",  label: "R1 Reprezentant 1",           koef: 87.5,  rank: 3 },
  { id: "VR2", label: "VR2 Vedoucí reprezentantů 2", koef: 100.0, rank: 4 },
  { id: "VR3", label: "VR3 Vedoucí reprezentantů 3", koef: 112.5, rank: 5 },
  { id: "VR4", label: "VR4 Vedoucí reprezentantů 4", koef: 125.0, rank: 6 },
  { id: "M1",  label: "M1 Obchodní vedoucí",         koef: 137.5, rank: 7 },
  { id: "M1+", label: "M1+ Obchodní vedoucí senior", koef: 150.0, rank: 8 },
  { id: "M2",  label: "M2 Oblastní vedoucí",         koef: 162.5, rank: 9 },
  { id: "D1",  label: "D1 Oblastní ředitel",         koef: 175.0, rank: 10 },
  { id: "D2",  label: "D2 Regionální ředitel",       koef: 187.5, rank: 11 },
  { id: "D3",  label: "D3 Zemský ředitel",           koef: 200.0, rank: 12 },
  { id: "SD",  label: "SD Senior ředitel",           koef: 200.0, rank: 13 },
  { id: "SSD", label: "SSD Super Senior ředitel",    koef: 200.0, rank: 14 },
];

export const getKoefForPosition = (id) => {
  const p = CAREER_POSITIONS.find((x) => x.id === id);
  return p ? p.koef : 87.5;
};

// Pipeline stages — moderní gradient paleta (růžová → fialová → modrá → tyrkysová → zelená)
// Inspirace: Raynet sales funnel + high-end SaaS pipelines (Pipedrive, HubSpot Sales).
// `short` se používá v kompaktních pohledech (mobil, rail), `label` je hlavní název fáze.
export const PIPELINE_STAGES = [
  { id: "lead",    label: "Lead",            short: "Lead",     labelSk: "Lead",          shortSk: "Lead",     color: "var(--faint)", desc: "Kontakt z Projektu 100, ještě nevoláno" },
  { id: "calling", label: "Volání",          short: "Volání",   labelSk: "Volanie",       shortSk: "Volanie",  color: "#6D48B8", desc: "Obvolává se (Zrcadlo volání)" },
  { id: "a1",      label: "Představení",     short: "15 min",   labelSk: "Predstavenie",  shortSk: "15 min",   color: "#A4436B", desc: "Dohodnuta první schůzka — představení (15 min)" },
  { id: "a2",      label: "Analýza",         short: "Analýza",  labelSk: "Analýza",       shortSk: "Analýza",  color: "#C74E22", desc: "Analýza finanční situace klienta" },
  { id: "p1",      label: "Finanční plán",   short: "Fin. plán",labelSk: "Finančný plán", shortSk: "Fin. plán",color: "#D69412", desc: "Tvorba a kalkulace finančního plánu" },
  { id: "p2",      label: "Prezentace",      short: "Prezent.", labelSk: "Prezentácia",   shortSk: "Prezent.", color: "#7FA62B", desc: "Prezentace plánu / řešení námitek" },
  { id: "signed",  label: "Podpis",          short: "Podpis",   labelSk: "Podpis",        shortSk: "Podpis",   color: "#0FBF62", desc: "Podepsaná smlouva, spočítat BJ" },
  { id: "servis",  label: "Servis",          short: "Servis",   labelSk: "Servis",        shortSk: "Servis",   color: "#0AA653", desc: "Aktivní klient v servisu — fixace, výročí" },
  { id: "done",    label: "Dokončeno",       short: "Hotovo",   labelSk: "Dokončené",     shortSk: "Hotovo",   color: "#045E30", desc: "Všechny plánované produkty uzavřeny" },
  { id: "lost",    label: "Ztraceno",        short: "Ztr.",     labelSk: "Stratené",      shortSk: "Strat.",   color: "var(--negative-text)", desc: "Neuzavřeno / nemá zájem" },  // 5. 10. 2026: dřív var(--accent) — v Lime zelená = úspěch (barva = 1 význam)
];

/* Lokalizovaný název fáze — přijme id nebo objekt fáze + jazyk ("cs"/"sk"). */
export const psLabel = (stage, lang) => {
  const s = typeof stage === "string" ? PIPELINE_STAGES.find((x) => x.id === stage) : stage;
  if (!s) return typeof stage === "string" ? stage : "";
  return lang === "sk" && s.labelSk ? s.labelSk : s.label;
};
export const psShort = (stage, lang) => {
  const s = typeof stage === "string" ? PIPELINE_STAGES.find((x) => x.id === stage) : stage;
  if (!s) return typeof stage === "string" ? stage : "";
  return lang === "sk" && s.shortSk ? s.shortSk : s.short;
};

/* BJ klienta — JEDNO pravidlo pro KPI i řádek tabulky (CRM-10, 18. 10. 2026).
 * Dřív KPI „Podepsáno" bralo signed_bj jen u Podpisu/Servisu, kdežto řádek
 * ukazoval zeleně signed_bj u kohokoli (Prezentace s 9999999 zeleně, KPI 0).
 * Nezadáno (null/""/nečíslo) ≠ 0: výslovná nula se ukáže jako „0". */
const PODEPSANE_FAZE = ["signed", "servis"];
const cisloNeboNull = (v) => {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};
export const bjKlienta = (c) => {
  if (PODEPSANE_FAZE.includes(c?.stage)) {
    const v = cisloNeboNull(c.signed_bj);
    return v === null ? { druh: null, hodnota: null } : { druh: "podepsano", hodnota: v };
  }
  const v = cisloNeboNull(c?.estimate_bj);
  return v === null ? { druh: null, hodnota: null } : { druh: "odhad", hodnota: v };
};

export const CONTACT_SOURCES = [
  { id: "project100", label: "Projekt 100" },
  { id: "project30",  label: "Projekt 30 (nábor)" },
  { id: "marketing",  label: "Marketing" },
  { id: "recommendation", label: "Doporučení" },
  { id: "direct",     label: "Přímý kontakt" },
  { id: "servis",     label: "Servis" },
  { id: "web_lead",   label: "Web / vizitka" },
  /* Hodnoty, které dřív znal jen select ve složce klienta (CRM-04, 18. 10. 2026) —
     jeden číselník pro složku, leady i Zrcadlo volání (lib/crm/puvodLeadu.js). */
  { id: "reklama",    label: "Reklama" },
  { id: "web",        label: "Web" },
  { id: "leadovac",   label: "Leadovač" },
  { id: "akce",       label: "Akce/Event" },
  { id: "soc_sit",    label: "Soc. sítě" },
  { id: "jine",       label: "Jiné" },
];
/* Starší hodnoty ze selectu složky, které mají v číselníku jiné id. */
export const CONTACT_SOURCE_ALIASY = { doporuceni: "recommendation" };

export const CONTACT_CATEGORIES = [
  { id: "A", label: "A-klient", color: "#D69412" },
  { id: "B", label: "B-klient", color: "#7FA62B" },
  { id: "C", label: "C-klient", color: "#C74E22" },
];

export const CALL_STATUSES = [
  { id: "not_reached", label: "Nedovoláno",     color: "#D69412" },
  { id: "meeting",     label: "Schůzka",        color: "#0AA653" },
  { id: "call_later",  label: "Zavolat později", color: "#D69412" },
  { id: "not_interested", label: "Nemá zájem",  color: "var(--accent)" },
  { id: "callback",    label: "Zpětné volání",  color: "#6D48B8" },
];

export const RELATIONSHIP_TYPES = [
  { id: "family", label: "Rodina" },
  { id: "friend", label: "Přítel" },
  { id: "acquaintance", label: "Známý" },
  { id: "colleague", label: "Kolega" },
  { id: "neighbor", label: "Soused" },
  { id: "none", label: "Žádný" },
];

export const P100_CATEGORIES = [
  { id: "school", label: "Ze školy (ZŠ, SŠ, VŠ, vojna)", tips: ["Ze svého adresáře", "Od svých známých", "Z klubových seznamů", "Z telefonních seznamů", "Z dokumentů školského řádu", "Z matričního úřadu"] },
  { id: "work", label: "Z minulého zaměstnání", tips: ["Bývalé kolegy a kolegyně", "Dřívější zákazníky a konkurenty", "Členy komor a sdružení", "Bývalé účastníky seminářů, kurzů a školení"] },
  { id: "partner", label: "Přes partnera a děti", tips: ["Kolegy a spolužáky partnera", "Organizace k nimž partner patří", "Okruh známých mého partnera", "Rodiče spolužáků a kamarádů dětí", "Známé a přátele našich dětí", "Vychovatele a učitele dětí"] },
  { id: "family", label: "Příbuzní", tips: ["Z matčiny strany", "Z otcovy strany", "Z partnerovy strany", "Ze strany přátel a známých"] },
  { id: "sport", label: "Sport, koníčky a okolí", tips: ["Spoluhráče, členy spolků a sponzory", "Protihráče, rozhodčí", "Lidi se stejnými koníčky (IT, hudba, divadlo, foto)", "Lidi z obchodů, řemesel a služeb"] },
  { id: "home", label: "Bydliště — minulé a současné", tips: ["Bývalé sousedy a přátele", "Současné sousedy a přátele", "Majitele pozemků a domů", "Pronajímatele a makléře"] },
  { id: "holiday", label: "Dovolené", tips: ["Pracovníky CK, průvodce", "Gastronomy a hoteliéry", "Obsluhující personál", "Známé z dovolené"] },
  { id: "house", label: "Mám vlastní dům / byt", tips: ["Architekty, stavitele, dodavatele", "Bývalého majitele, nájemníky, makléře, notáře", "Listonoše, daňové poradce, právníka", "Instalatéry, údržbáře, malíře, elektrikáře, ostatní řemeslníky"] },
  { id: "charity", label: "Dobročinná práce / organizace / kluby", tips: ["Kolegy, sponzory, předsedy, členy", "Chráněnce"] },
  { id: "events", label: "Společenské události a oslavy", tips: ["Z narozenin, svátků, jubileí", "Z večírků, svateb", "Z dětských slavností a školních oslav"] },
  { id: "daily", label: "Denní kontakty", tips: ["Prodavače potravin", "Zaměstnance čistíren a prádelen", "Obuvníky a prodavače textilu", "Kadeřníky, pekaře, řezníky, trafikanty", "Doktory, zubaře a lékárníky", "Pracovníky bank a veřejných institucí"] },
];

export const IK_OUTLINE = [
  "Co se povedlo? Co je nového? Co chceš prioritně řešit?",
  "Okomentovat jednotlivé klienty",
  "Kontrola intervencí z portálu",
  "Kontrola storna smluv — report storna",
  "Kontrola odevzdávání smluv — zadávání úkolů na příští IK",
  "Fond provozní — nastavení trvalého příkazu",
  "Fond kancl — nastavení trvalého příkazu",
  "Zhodnotit plnění měsíčního cíle",
  "Kde by se chtěl zlepšit / kde vidím prostor já (manažer)?",
  "Školení na která může být přihlášen",
  "Rekapitulace úkolů na příště (samostudium, doporučená četba, klientské úkoly)",
];

export const PRODUCT_TYPES = [
  { id: "zp",         label: "ŽP",         icon: "Shield" },
  { id: "hypo",       label: "Hypotéka",   icon: "Home" },
  { id: "invest",     label: "Investice",  icon: "TrendingUp" },
  { id: "property",   label: "Nemovitost", icon: "Building" },
  { id: "auto",       label: "Auto",       icon: "Car" },
  { id: "nonlife",    label: "Neživotní",  icon: "Umbrella" },
];
